import ManagementTable from "src/components/pages/Management/ManagementTable/ManagementTable";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { useGetApi } from "src/hooks";
import { PageContainer } from "src/styled";

import { type IPermissionItem } from "./Permissions.types";

const mapPerms = (data: any) =>
  data?.data?.content as { list: IPermissionItem[] };

const Permissions = () => {
  const { data, isLoading } = useGetApi({
    request: "get-management",
    body: { _sect: "_permissions" },
    mapper: mapPerms,
  });

  return (
    <PageContainer>
      <Breadcrumbs border={false} />
      <ManagementTable
        section="_permissions"
        data={data?.list ?? []}
        loading={isLoading}
      />
    </PageContainer>
  );
};

export default Permissions;
